/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { DELIVERY_TYPE_NORMAL } from "../models/Delivery";

import { useDeliveriesStore, useLoadingStore } from "../stores/hooks";

import {
  DELAY_REASONS,
  PICKUP_DELAY_REASONS,
  REASON_ETC,
  REASON_NEXT_DELIVERY,
} from "../utils/delay";

const ReasonItem = ({ active, reason, onSelect }) => {
  const handleSelect = () => {
    onSelect(reason);
  };

  return (
    <div>
      <label className="block mb-10" onClick={handleSelect}>
        <input
          type="radio"
          name="corp"
          defaultChecked={!!active}
          className="mr-5"
        />
        {reason.text}
      </label>
    </div>
  );
};

function DeliveryDelay() {
  const params = new URLSearchParams(window.location.search);
  const bookId = params.get("bookId");
  const isPickup = params.get("isPickup")
    ? JSON.parse(params.get("isPickup"))
    : false;
  const skipStatusChange = params.get("skipStatusChange")
    ? JSON.parse(params.get("skipStatusChange"))
    : false;
  const latitudeParam = params.get("latitude");
  const longitudeParam = params.get("longitude");
  const latitude =
    latitudeParam == null || latitudeParam === ""
      ? undefined
      : Number(latitudeParam);
  const longitude =
    longitudeParam == null || longitudeParam === ""
      ? undefined
      : Number(longitudeParam);

  const { delivery } = useDeliveriesStore().state;
  const { ...actions } = useDeliveriesStore();

  const { ...loadingActions } = useLoadingStore();

  const { register, handleSubmit, reset, setValue, watch, setFocus } =
    useForm();

  const [load, setLoad] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (bookId) {
      fetchById();
    }
  }, [bookId]);

  useEffect(() => {
    reset({
      code: isPickup ? PICKUP_DELAY_REASONS[0].code : DELAY_REASONS[0].code,
      text: isPickup ? PICKUP_DELAY_REASONS[0].text : DELAY_REASONS[0].text,
    });

    setLoad(true);
  }, [isPickup]);

  const fetchById = async () => {
    try {
      await actions.fetchStatusWithOrderId(bookId);
    } catch (e) {
      window.alert(`배송 조회에 실패했습니다. ${e.message}`);
    }
  };

  // 배송 지연 취소
  const handleCancel = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ close: true }));
    }
  };

  // 사유 선택
  const handleSelectReason = (reason) => {
    setValue("code", reason.code);
    setValue("text", reason.text);
    setValue("etcText", "");
  };

  // 직접입력 전체 삭제
  const handleDeleteEtcText = () => {
    setValue("etcText", "");
  };

  const onSubmit = async ({ code, text, etcText }) => {
    if (code && text) {
      try {
        if (code === REASON_ETC && !etcText) {
          setErrorMessage("기타 사유를 입력해주십시오");
          setFocus("etcText");

          return;
        }

        loadingActions.startLoading();

        const reasonText = `${text}${
          code === REASON_ETC && etcText ? `(${etcText})` : ""
        }`;

        const data = {
          bookId,
          reason: reasonText,
          reasonType: code,
          processType: isPickup ? "pickup" : "delivery",
          skipStatusChange,
          latitude,
          longitude,
        };

        await actions.setDelay(data);

        if (window.ReactNativeWebView) {
          // 문자 발송 여부 확인
          const isExcludedSpot =
            delivery?.spot?.code === "P0020" ||
            delivery?.spot?.code === "10625";
          const receiverMobile =
            delivery?.receiverSmsMobile ||
            delivery?.receiverMobile ||
            delivery?.receiverMobile2;

          const canSendSms =
            delivery &&
            delivery.type === DELIVERY_TYPE_NORMAL &&
            receiverMobile &&
            !isExcludedSpot &&
            code !== REASON_NEXT_DELIVERY;

          window.ReactNativeWebView.postMessage(
            JSON.stringify({ submitted: true, reasonText, canSendSms }),
          );
        }
      } catch (e) {
        window.alert(`배송지연 사유 등록에 실패했습니다.. ${e.message}`);
      }

      loadingActions.finishLoading();
    }
  };
  return (
    <div className="p-15">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-20">
          <h5 className="font-medium text-18 mb-10">
            {delivery?.bookId}{" "}
            {isPickup
              ? delivery?.senderAddress || delivery?.senderAddressRoad || ""
              : delivery?.receiverAddress ||
                delivery?.receiverAddressRoad ||
                ""}{" "}
            {isPickup ? "수거지연" : "배송지연"} 사유를 선택해주세요.
          </h5>
          <div>
            {load &&
              (isPickup ? PICKUP_DELAY_REASONS : DELAY_REASONS).map(
                (reason) => {
                  return (
                    <ReasonItem
                      key={reason.code}
                      active={reason.code === watch("code")}
                      reason={reason}
                      onSelect={handleSelectReason}
                    />
                  );
                },
              )}
            <input name="code" {...register("code")} hidden />
            <input name="text" {...register("text")} hidden />
            <div className="bg-[#f6f6f6] p-5 flex justify-between items-center ml-10">
              <input
                type="text"
                className="bg-transparent max-w-[calc(100vw-120px)] flex-1"
                {...register("etcText")}
                disabled={watch("code") !== REASON_ETC}
                onChange={() => {
                  setErrorMessage("");
                }}
              />
              <button
                type="button"
                className="text-[#999] p-5 w-50"
                onClick={handleDeleteEtcText}
              >
                삭제
              </button>
            </div>
            {errorMessage && (
              <div className="text-red text-12 mb-10 ml-10">{errorMessage}</div>
            )}
          </div>
        </div>
        <div className="flex justify-center items-center">
          <button type="button" className="flex-1 p-10" onClick={handleCancel}>
            취소
          </button>
          <button type="submit" className="text-orange flex-1 p-10">
            확인
          </button>
        </div>
      </form>
    </div>
  );
}

export default DeliveryDelay;
